export default build =>
    build.mutation({
        query(payload) {
            console.log("payload in delete district",payload)
            return {
                url: '/exam/deletedistrict',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allDistricts'],
    })
